import * as React from 'react';

export interface OwnProps {
    screenName: string;
    hasDirty: boolean;
}

export interface DispatchProps {
    setHasDirtyData: (screeName: string, hasDirtyData: boolean) => void;
}

export type Props = DispatchProps & OwnProps;

export default class App extends React.Component<Props> {
    componentDidMount() {
        if (this.props.hasDirty) {
            this.props.setHasDirtyData(this.props.screenName, this.props.hasDirty);
        }
    }

    componentWillUnmount() {
        this.props.setHasDirtyData(this.props.screenName, false);
    }

    UNSAFE_componentWillReceiveProps(nextProps: OwnProps) {
        if (nextProps.hasDirty !== this.props.hasDirty) {
            this.props.setHasDirtyData(this.props.screenName, nextProps.hasDirty);    
        }
    }

    render() {
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/components/shared/dirty-data/DirtyInformer.tsx